export const N8N_IO_BASE_URL = 'https://api.n8n.io/api/';
